<div class="cf-dlg">

  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>edit</mat-icon></div>
    <div>
      <h2 class="cf-dlg-title">Renombrar</h2>
      <p class="cf-dlg-subtitle">Introduce el nuevo nombre</p>
    </div>
  </div>

  <div class="cf-dlg-body">
    <div class="cf-dlg-mismatch" *ngIf="error">
      <mat-icon>error_outline</mat-icon>
      {{ error_msg }}
    </div>

    <app-input inputType="text" placeholder="Nuevo nombre" [isRequired]="true" [(ngModel)]="newName"></app-input>
  </div>

  <div class="cf-dlg-footer">
    <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="cf-dlg-btn-primary" (click)="renameElement()" [disabled]="!newName">
      <mat-icon>check</mat-icon> Renombrar
    </button>
  </div>

</div>
